import { useEffect, useState } from 'react'
import { connect } from 'redaction'
import { BigNumber } from 'bignumber.js'
import { FormattedMessage } from 'react-intl'
import CSSModules from 'react-css-modules'
import { Link, NavLink, withRouter } from 'react-router-dom'
import { TransakConfig, Transak } from '@transak/transak-sdk';

import styles from './index.scss';
import Sider from 'shared/components/Sider'


const Simplex = (props) => {


  const [modal, setModal] = useState(false);
  const [transakType, setTransakType] = useState('');
  const [link, setLink] = useState('');


  useEffect(() => {
    const { location, history, match: { params: { type } } } = props;
    // let link = `https://global.transak.com/?apiKey=797bd38e-f0ce-4441-ab83-a6e9acb203c5&walletAddress=${props.userData.tokensData["{matic}usdc"].address}&disableWalletAddressForm=true&email=${props.userData.email}&defaultFiatCurrency=USD&colorMode=LIGHT&productsAvailed=${type === 'on-ramp' ? 'BUY' : 'SELL'}&defaultCryptoCurrency=USDC&network=polygon`
    // if (type === 'off-ramp') {
    //   link = link + `&defaultCryptoAmount=${props.userData.tokensData["{matic}usdc"].balance}&cryptoCurrencyCode=USDC&exchangeScreenTitle=Withdraw Cryptop from you wallet`
    // } else {
    //   link = link + `&exchangeScreenTitle=Acquire Crypto for your Kaxaa Wallet`
    // }

    const transakConfig = {
      apiKey: '797bd38e-f0ce-4441-ab83-a6e9acb203c5', // (Required)
      environment: Transak.ENVIRONMENTS.PRODUCTION, // (Required)
      containerId: 'transakIframe',
      defaultCryptoCurrency: 'USDC', // (Required) The crypto currency you want to buy/sell
      defaultFiatCurrency: 'USD', // (Required) The fiat currency you want to use
      walletAddress: props.userData.tokensData["{matic}usdc"].address, // (Required) The wallet address where the crypto will be sent to
      email: props.userData.email, // (Required) The email address of the user
      defaultCryptoAmount: props.userData.tokensData["{matic}usdc"].balance, // The default amount of crypto currency to be bought/sold
      exchangeScreenTitle: type === 'on-ramp' ? 'Acquire Crypto for your Kaxaa Wallet' : 'Withdraw Crypto from your wallet', // The title of the exchange screen
      cryptoCurrencyCode: 'USDC', // The crypto currency code
      fiatCurrency: 'USD', // The fiat currency to be used
      disableWalletAddressForm: true, // Disable the wallet address form
      productsAvailed: type === 'on-ramp' ? 'BUY' : 'SELL',
      network: 'polygon', // The network to be used
      colorMode: 'LIGHT', // The color mode of the widget
      themeColor: '#a8c416', // The theme color of the widget
    };

    let transak = new Transak(transakConfig);


    transak.init();
    setTransakType(type);

    return () => {
      transak.close();
    }
  }, [])


  const toggleModal = () => {
    this.setModal(!modal);
  };



  return (
    <Sider
      transakType={transakType}
    >
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <div id="transakIframe" style={{ width: '480px', border: 0, height: '650px' }}></div>
        {/* <iframe id="transakIframe"
          src={link}
          allow="camera;microphone;payment"
          style={{ width: '480px', border: 0, height: '650px' }}
        >
        </iframe> */}
        {modal && (
          <div className={`modal-custom matic-modal ${modal ? 'show-modal' : ''}`}>
            <div className="modal-content">
              <h2>How to Acquire KAX from transak</h2>

              <a className="btn btn" onClick={toggleModal}>
                Close
              </a>
            </div>
          </div>
        )
        }
      </div>
    </Sider>
  );
}

export default connect({
  userData: 'user',
})(withRouter(CSSModules(Simplex, styles)))
